import { ResponseType } from "../../types/apiTypes";

function filterResponse(apiResponse: any[], isMobile: boolean): any[] {
  if (isMobile) {
    const filteredResponse: any[] = [];
    const processedTurnIds = new Set<string>();

    apiResponse.forEach((item) => {
      const { turn_id, type } = item;

      // Skip already processed turn_ids
      if (processedTurnIds.has(turn_id)) return;

      // Filter entries by turn_id
      const turnEntries = apiResponse.filter(
        (entry) => entry.turn_id === turn_id
      );
      processedTurnIds.add(turn_id);

      const videoEntry = turnEntries.find((entry) => entry.type === "video");
      const blogEntry = turnEntries.find((entry) => entry.type === "blog");
      const textEntry = turnEntries.find((entry) => entry.type === "text");

      if (videoEntry && blogEntry && textEntry) {
        // Update video entry, remove blog and text entries
        const modifiedVideo = {
          ...videoEntry,
          body: {
            ...videoEntry.body,
            video_title: "",
            isInitial: true,
            video_text: textEntry.body.text,
          },
        };
        filteredResponse.push(modifiedVideo);
      } else if (blogEntry && textEntry) {
        // Update blog entry, remove text entry
        const modifiedBlog = {
          ...blogEntry,
          body: {
            ...blogEntry.body,
            blog_title: "",
            isInitial: true,
            blog_text: textEntry.body.text,
          },
        };
        filteredResponse.push(modifiedBlog);
      } else {
        // Keep original entries if none of the conditions match
        filteredResponse.push(...turnEntries);
      }
    });

    return filteredResponse;
  }
  return apiResponse;
}

// sort messages if turn_id is the same, sort by type
function sortApiResponse(apiResponse: any[], isMobile: boolean): any[] {
  apiResponse = filterResponse(apiResponse, isMobile);
  // Use the sort() method to sort the array
  apiResponse.sort((a, b) => {
    // First, compare by turn_id
    const turnIdComparison = parseInt(a.turn_id) - parseInt(b.turn_id);
    if (turnIdComparison !== 0) {
      return turnIdComparison;
    }

    // If turn_id is the same, prioritize sorting by type
    // Define the priority order of types
    const typeOrder: { [key: string]: number } = {
      [ResponseType.Video]: 1,
      [ResponseType.Blog]: 2,
      [ResponseType.WebLink]: 3,
    };

    // Get the priority of types
    const aTypePriority = typeOrder[a.type] || Infinity;
    const bTypePriority = typeOrder[b.type] || Infinity;

    // Compare by type priority
    return aTypePriority - bTypePriority;
  });

  return apiResponse;
}
export function sortFilterMessages(
  messages: any[],
  isMobile: boolean,
  sortMsg: boolean
): any[] {
  return sortMsg ? sortApiResponse(messages.slice(), isMobile) : messages;
}

export function sortModalConfig(modalConfig: any[], isMobile: boolean): any[] {
  return sortApiResponse(modalConfig.slice(), isMobile);
}
